import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/new-arrivals/page.tsx");
